import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { BaseAsyncValue } from '@ordersnproducts/modules/shared/models/async-value';
import { getOneClickTimeWindowsState } from '@ordersnproducts/modules/one-click-order/selectors/one-click-time-windows.selector';

export class OneClickPreviewTimeWindowLoadingProvider extends BaseAsyncValue<boolean> {
  getValue(): Observable<boolean> {
    return this.store.select(getOneClickTimeWindowsState).pipe(
      filter(state => !!state),
      map(state => state.loading),
    );
  }
}
